import AmexEventImagePreview from './AmexEventImagePreview';

export default AmexEventImagePreview;
